<template>
    <div class="commentWrap" ref="commentWrap" v-if="false">
        <div class="commentHeader">
            <span>我有话说</span>
            <div class="commentInfo">
                共 <span class="commentInfoData">{{total}}</span> 条评论
                <!-- <span class="commentInfoData">{{personNum}}</span>人参与 -->
            </div>
        </div>
        <div class="commentSendBox">
            <div class="commentNoLogin" v-if="!isLogin">
                请发表您的意见 （游客无法发送评论，请 <span @click="handleClickLogin">登录</span> or <span @click="handleClickRegister">注册</span> 网站)
            </div>
            <textarea class="commentSendInput" @click="clickTextarea" :placeholder="isLogin ? '写下你的评论...' : ''" v-model="commentContent"></textarea>
            <div class="commentSendBtn" @click="handleSendComment">发送</div>
        </div>
        <div class="commentContTitle">
            <div class="commentContTitleItem curp" :class="{
          'commentContTitleItemActive': select === 'hot'
        }" @click="clickHot" v-if="hotList.length > 0">最热</div>
            <div v-if="hotList.length > 0">/</div>
            <div class="commentContTitleItem" :class="{
          'commentContTitleItemActive': select === 'all',
          'curp':hotList.length > 0
        }" @click="clickAll">全部</div>
        </div>
        <div class="commentContWrap" v-show="select === 'hot' && hotList.length > 0">
            <CommentItem v-for="(item, key) in hotList" :key="key" :cont="item" :like="commentLikes[item.pid + '_' + item.id]" :likeKey="item.pid + '_' + item.id" :setLike="handleSetLike" :pid="pid"
                :id="item.id" :insertNewReply="insertNewReply">
                <ReplyItem v-for="repItem in item.bereply" :key="repItem.id" :cont="repItem"></ReplyItem>
            </CommentItem>
        </div>
        <div class="commentContWrap" v-show="select === 'all' && allList.length > 0">
            <CommentItem v-for="(item, key) in allList" :key="key" :cont="item" :like="commentLikes[item.pid + '_' + item.id]" :likeKey="item.pid + '_' + item.id" :setLike="handleSetLike"
                :isNew="!!item.isNew" :pid="pid" :id="item.id" :insertNewReply="insertNewReply">
                <ReplyItem v-for="repItem in item.bereply" :key="repItem.id" :cont="repItem"></ReplyItem>
            </CommentItem>
        </div>
        <div class="commentLoadMore" v-show="allList.length > 0 && !nomore && select === 'all'" @click="loadComment">点击加载更多</div>
        <div class="commentContEmpty" v-show="allList.length === 0">暂无评论</div>
    </div>
</template>

<script>
import CommentItem from './comment'
import ReplyItem from './reply'
import * as common from './utils/common'
import * as actions from './actions'
//import * as client from './utils/client'
import event from './utils/event'

export default {
    name: 'Comment',
    // props: ['seq', 'setCommentNum'],
    components: {
        CommentItem,
        ReplyItem
    },
    watch: {
        /**
         * 监听 seq 变化重新获取评论
         * @param {Number|String} newSeq 新的 seq
         */
        'propsData.seq': {
            handler: function (newSeq) {
                if (!newSeq) return
                this.getComment()
                this.commentContent = ''
            },
            immediate: true
        },

        /**
     * 判断如最热列表内无数据，则选中全部
     * @param {Array} newList 新的最热列表
     */
        hotList: {
            handler: function (newList) {
                if (newList.length === 0) {
                    this.select = 'all'
                } else {
                    this.select = 'hot'
                }
            },
            deep: true
        },

        /**
     * 向父组件传递评论总数
     */
        total: function (newNum) {
            // if (this.setCommentNum) {
            this.sendMsg({ total: newNum })
            // }
        }
    },
    computed: {
        isLogin: function () {
            if (location.href.includes('localhost')) { // 为调试
                return true
            }
            return common.isLogin()
        }
    },
    data() {
        return {
            pid: 0,
            seq: '615908014',
            select: 'hot',
            total: 0,
            personNum: 8,
            hotList: [],
            allList: [],
            commentLikes: {},
            nomore: false,
            commentContent: ''
        }
    },
    props: {
        propsData: {
            default() {
                return {
                    seq: "",
                }
            },
            type: Object,
        }
    },
    mounted: function () {
    },
    methods: {
        clickHot() {
            this.$sendStat(`pc_newschrome_${window.statSeq}.comments.rankbyheat`)
            this.select = 'hot'
        },
        clickAll() {
            this.$sendStat(`pc_newschrome_${window.statSeq}.comments.rankbyall`)
            this.select = 'all'
        },
        clickTextarea() {
            this.$sendStat(`pc_newschrome_${window.statSeq}.inputbox.click`)
        },
        sendMsg(e) {
            this.$emit('updateMessage', {
                from: 'comment',
                data: e
            })
        },
        /**
     * 获取评论内容
     */
        getComment: async function () {
            this.hotList = []
            this.allList = []
            this.nomore = false
            try {
                let data = await actions.getComment.call(this, this.propsData.seq)
                console.log('评论内容————————', data)
                let hotList = common.getDeepObj(['result', 'hotreply'], data) || []
                hotList.map(item => {
                    if (!item.bereply) {
                        item.bereply = []
                    }
                })
                let allList = common.getDeepObj(['result', 'reply'], data) || []
                allList.map(item => {
                    if (!item.bereply) {
                        item.bereply = []
                    }
                })
                this.hotList = hotList
                this.allList = this.allList.concat(allList)
                if (allList.length < 10) {
                    this.nomore = true
                }
                this.total = common.getDeepObj(['result', 'floor'], data) || 0
                this.pid = common.getDeepObj(['info', 'tid'], data) || 0

                let likesArr = [].concat(hotList, allList)
                let keys = [...new Set(likesArr.map(item => item.pid + '_' + item.id))]

                // let likes = await actions.getCommentLikes.call(this, keys)
                // console.log('likes', likes)
                // if (likes.errorcode === 0) {
                //   this.commentLikes = Object.assign({}, this.commentLikes, likes.result)
                // }

                // 评论区获取点赞数量的接口改动
                // 0.0.5
                // this.$commonApi.getLikesInPromise({
                //   key: keys,
                //   log: 1,
                //   field: "likes",
                //   app: 'news',
                //   _: (new Date()).valueOf()
                // }).then(res=>{
                //   console.log('commonApi评论区点赞数量', res);
                //   if(res.errorcode === 0) {
                //     this.commentLikes = Object.assign({}, this.commentLikes, res.result)
                //   }
                // }).catch(err=>{
                //   console.log('getLikes err-----', err)
                // })
                // 0.0.9
                commonApi.getLikes({
                    key: keys,
                    log: 1,
                    field: "likes",
                    app: 'sns',
                    _: (new Date()).valueOf()
                }).then(res => {
                    console.log('新commonApi评论区点赞数量', res);
                    if (res.errorcode === 0) {
                        this.commentLikes = Object.assign({}, this.commentLikes, res.result)
                    }
                })

            } catch (e) {
                console.warn(e)
            }
        },

        /**
     * 加载更多评论
     */
        loadComment: async function () {
            try {
                let data = await actions.loadComment.call(this, {
                    pid: this.pid,
                    cid: this.allList[this.allList.length - 1].id
                })
                let allList = common.getDeepObj(['result', 'reply'], data) || []
                allList.map(item => {
                    if (!item.bereply) {
                        item.bereply = []
                    }
                })

                this.allList = this.allList.concat(allList)
                if (data.errorCode === -12 || allList.length < 10) {
                    this.nomore = true
                }

                let likesArr = [].concat(allList)
                let keys = [...new Set(likesArr.map(item => item.pid + '_' + item.id))]

                if (keys) {
                    commonApi.getLikes({
                        key: keys,
                        log: 1,
                        field: "likes",
                        app: 'sns'
                    }).then(res => {
                        console.log('新commonApi评论区点赞数量', res);
                        if (res.errorcode === 0) {
                            this.commentLikes = Object.assign({}, this.commentLikes, likes.result)
                        }
                    })
                }
                // let likes = await actions.getCommentLikes.call(this, keys)
                // if (likes.errorcode === 0) {

                // }
                // this.$sendStat('pcnewsbrowser_pinglunchakan')
                this.$sendStat(`pc_newschrome_${window.statSeq}.comments.load.click`);
            } catch (e) {
            }
        },

        /**
     * 执行点赞
     */
        handleSetLike: function (key) {
            if (this.commentLikes[key]) {
                this.commentLikes[key].likes += 1
                this.commentLikes[key].flag = 1
            }
        },

        /**
     * 发送被点击
     * 如 pid 为 0，则说明当前文章无评论，需要根据文章 seq 创建 pid
     */
        handleSendComment: async function () {
            // this.$sendPoint('plfs')


            let cont = this.commentContent
            let pid = this.pid
            if (pid === 0) {
                try {
                    let data = await actions.createPid(this.propsData.seq)
                    if (data.errorCode === 0) {
                        pid = data.result
                        this.pid = data.result
                    } else {
                        this.$client.showBrowserDlgTip({ text: '评论失败' })
                        return
                    }
                } catch (e) {
                    console.warn(e)
                }
            }
            this.$sendStat(`pc_newschrome_${window.statSeq}.comments.fasong`)
            // this.$sendStat('pcnewsbrowser_pinglunfasong')
            // eslint-disable-next-line
            let userid = getUserid()
            // eslint-disable-next-line
            let username = getAccount()
            if (!cont) return
            if (!userid) return
            if (!username) return
            let avatar = `http://u.thsi.cn/avatar/${userid.slice(-4)}/${userid}.gif`
            let date = new Date()
            let utime = `${common.fillZero(date.getMonth() + 1)}-${common.fillZero(date.getDate())} ${common.fillZero(date.getHours())}:${common.fillZero(date.getMinutes())}`
            let commentObj = {
                cont: cont,
                userid: userid,
                uname: username,
                avatar: avatar,
                utime: utime,
                to: userid,
                pid: pid
            }
            this.commentContent = ''
            try {
                let data = await actions.sendComment.call(this, commentObj)
                if (data.errorCode === 0) {
                    this.$client.showBrowserDlgTip({ text: '评论成功' })

                    // this.$sendPoint('plcg')
                    this.$sendStat(`pc_newschrome_${window.statSeq}.comments.toast`)

                    this.insertNewComment({
                        content: cont,
                        nickname: username,
                        avatar: avatar,
                        ctime: Date.parse(new Date()) / 1000
                    })
                } else {
                    this.$client.showBrowserDlgTip({ text: data.errorMsg })
                }
            } catch (e) {
                console.warn(e)
            }
        },

        /**
     * 添加了新的评论
     * 在 allList 数组前面插入新的临时评论，isNew 字段为 true
     * @param {Object} opt 创建新的评论所需参数
     */
        insertNewComment: function (opt) {
            this.allList.unshift(Object.assign({}, opt, {
                isNew: true
            }))
            event.fire('commentSend')
        },

        /**
     * 添加了新的回复
     * @param {Object} opt 创建新的回复所需参数
     */
        insertNewReply: function (opt) {
            this.hotList.map((item, index) => {
                if (item.id === opt.rid) {
                    if (item.bereply) {
                        item.bereply.push(opt)
                    }
                    item.bereplynum += 1
                }
            })
            this.allList.map((item, index) => {
                if (item.id === opt.rid) {
                    if (item.bereply) {
                        item.bereply.push(opt)
                    }
                    item.bereplynum += 1
                }
            })
            event.fire('ReplySend')
        },

        /**
     * 点击了去注册
     */
        handleClickRegister: function () {
            this.$sendStat('pc_newschrome_regiter.click')
            this.$client.goRegister()
        },

        /**
     * 点击了登录
     */
        handleClickLogin: function () {
            this.$sendStat('pc_newschrome_login.click')
            let askLogin = confirm('登录将重启客户端，是否继续？')
            if (askLogin) {
                this.$client.goLogin()
            }
        }
    }
}
</script>

<style lang="less">
@import './index.less';
</style>
